import React, { Component } from 'react';
var classNames = require('classnames');
import {EnergoAll, ElectricBoiler, WoodFiredBoiler, Tank, Cell } from '../entries';
import {WithModal} from '../';
import styles from './style.css';
import * as trends from '../../trends.js';

const cellData = [

    {ps:['ti_6_96_1'], chartPs:trends.teplo_t7,  div_id:styles.Cell2, caption:"T °C", hint:"Т1 - температура наружного воздуха"},
    {ps:['ti_6_127_7'], div_id:styles.Cell3, caption:"Ртп(кВт)", hint:"Ртп - мощность потерь текущая"},
    {ps:['ti_6_127_8'], div_id:styles.Cell4, caption:"Рпп(кВт)", hint:"Рпп - мощность потерь за прошедший час"},
    {ps:['ti_6_127_1'],  div_id:styles.Cell5, caption:"Ртг(кВт)", hint:"Ртг - мощность генерации текущая" },
    {ps:['ti_6_127_2'], div_id:styles.Cell6, caption:"Рпг(кВт)", hint:"Рпг - мощность за прошедший час" },
    {ps:['ti_6_127_3'], div_id:styles.Cell7, caption:"Ртн(кВт)", hint:"Ртн - мощность потребления текущая" },
    {ps:['ti_6_127_4'], div_id:styles.Cell8, caption:"Рпн(кВт)", hint:"Рпн - мощность потребления за прошедший час" },
    {ps:['ti_6_127_9'],  div_id:styles.Cell9, caption:"Тз (часов)", hint:"Тз - запас хода в баке"},
    {ps:['ti_6_127_5'], div_id:styles.Cell10, caption:"Wз(кВт*ч)", hint:"Wз - запас энергии в баке"},
    {
        ps: ['ti_6_96_4'],
        chartPs: trends.teplo_t3,
        div_id: styles.Cell12,
        caption: "T °C",
        hint: "Т4 -температура в баке аккумуляторе"
    },
    {ps:['ti_6_127_6'], div_id:styles.Cell11, caption:"Wд(кВт*ч)", hint:"Wд -дефицит энергии в баке"}
];
export default class Energo extends WithModal {
    render() {
        return (
            <div className={[this.props.className,styles.App].join(' ')}>
                <div className={styles.canvases}>
                <EnergoAll {...this.props} canvas_id={styles.canvas0}/>
                <ElectricBoiler {...this.props} ps={['tc_6_93_201','tc_6_96_104']} canvas_id={styles.canvas1}/>
                <ElectricBoiler {...this.props} ps={['tc_6_93_201','tc_6_96_104']} canvas_id={styles.canvas2}/>
                <ElectricBoiler {...this.props} ps={['tc_6_93_201','tc_6_96_104']} canvas_id={styles.canvas5}/>
                <Tank {...this.props} ps={['ti_6_96_65', 'tc_6_96_110']} div_id={styles.canvas3} canvas_id="Random1490"/>


                    {
                    cellData.map(function(childData, i) {

                                return <Cell {...this.props}
                                             key={i}
                                             onClick={childData.chartPs && this.openModal.bind(this,childData.chartPs)}
                                             ps={childData.ps}
                                             div_id={childData.div_id}
                                             caption={childData.caption}
                                             hint={childData.hint}
                                />
                            }.bind(this))
                }

                <div className="capt" id={styles.capt2}>Температура зовнішнього повітря</div>
                <div className="capt" id={styles.capt3}>EK 2</div>
                <div className="capt" id={styles.capt4}>EK 1</div>
                <div className="capt" id={styles.capt6}>EK 3</div>
                <div className="capt" id={styles.capt5}>НАГРУЗКА</div>
                <div className={'triangleUp' + ' ' + styles.triangle1}></div>

                { (()=> {
                    return super.render();
                })()
                }
                </div>
                <div className="row">
                    <div className="col-md-6">
                    <p>
                        Ртп - мощность потерь в текущее время<br></br>
                        Рпп - мощность потерь за прошедший час<br></br>
                        Тз - запас хода в баке аккумуляторе<br></br>
                        Wз - запас энергии в баке аккумуляторе<br></br>
                        Wд -дефицит энергии в баке аккумуляторе
                    </p>
                    </div>
                    <div className="col-md-6">
                    <p>
                        Ртг - мощность генерируемая котлом в текущее время<br></br>
                        Рпг - мощность сгненерированная котлом за прошедший час<br></br>
                        Ртн - мощность потребляемая нагрузкой в текущее время<br></br>
                        Рпн - мощность потребленная нагрузкой за прошедший час
                    </p>
                        </div>
                </div>
                <div className="row col-md-12 screenText">
                    <p>Страница автоматизированного рабочего места (АРМ) «Энергетическая» в реальном времени отображает информацию об основных энергетических показателях работы узла электроиндукционного нагрева автоматизированного (ВЕНА). Позволяет визуально оценить запасы и дефицит энергии в теплоаккумуляторе, величину генерации и расхода тепловой энергии, потери тепла в системе.</p>
                    <p>Для просмотра показателей в виде графика за прошедший период наведите курсор на интересующий Вас показатель и, при появлении символа <i className="fa fa-hand-pointer-o"></i> ,  нажмите на левую кнопку мыши.</p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Energo/index.jsx